import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MissionSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Column - Mission Quote */}
          <motion.div
            className="lg:col-span-2 bg-beige-light rounded-3xl p-12 shadow-lg"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block bg-primary text-white px-4 py-2 rounded-full text-xs uppercase tracking-wider font-semibold mb-6">
              Our Mission
            </div>
            <div className="relative">
              <i className="ri-double-quotes-l text-6xl text-primary/20 absolute -top-4 -left-2"></i>
              <p className="text-3xl md:text-4xl font-serif italic text-neutral-gray leading-relaxed pl-8">
                Providing accessible, personalized mental wellness support to our community
              </p>
            </div>
          </motion.div>

          {/* Right Column - Who We Serve */}
          <motion.div
            className="lg:col-span-3"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-neutral-gray mb-6">
              Who We Serve
            </h2>
            <div className="space-y-4 text-lg text-neutral-gray/80 leading-relaxed mb-8">
              <p>
                Solutions Healthcare LLC is dedicated to providing comprehensive psychiatric care and mental wellness support to <strong>adults aged 18 and older</strong> and <strong>geriatric patients</strong> throughout Aurora, Colorado and surrounding communities.
              </p>
              <p>
                Our experienced clinicians deliver personalized, evidence-based treatment in a compassionate environment. We believe quality mental health care should be accessible to everyone, which is why we offer flexible care delivery options including in-office visits, telepsychiatry, and house calls.
              </p>
              <p>
                Whether you're seeking help for anxiety, depression, bipolar disorder, PTSD, or other mental health conditions, our team is here to support your journey toward wellness with dignity and respect.
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center space-x-2 text-primary hover:text-primary-dark font-semibold text-lg transition-colors cursor-pointer"
            >
              <span>Learn More About Us</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;